import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css";
import { parseTime, handleTree } from "@/utils/ruoyi";
// import {Layout as TinyLayout, Row as TinyRow, Col as TinyCol, Image, Button} from '@opentiny/vue'
// import { Breadcrumb as ElBreadcrumb,BreadcrumbItem as ElBreadcrumbItem  } from 'element-ui';
//
// Vue.use(TinyLayout)
// Vue.use(TinyRow)
// Vue.use(TinyCol)
// Vue.use(Image)
// Vue.use(Button)
// Vue.use(ElBreadcrumb)
// Vue.use(ElBreadcrumbItem)
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer);

Vue.config.productionTip = false;

Vue.prototype.parseTime = parseTime
Vue.prototype.handleTree = handleTree

new Vue({
  router,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
